import React, { useEffect, useState } from 'react'
import style from './AboutUs.module.css';
import LeadershipUpdated from '../LeadershipUpdated';
import VideoComponent from '../../components/VideoComponent';
import TopTalentCard from '../../components/TopTalentCard';
import SpecialTable from '../SpecialTable';
import Header from "../../components/Header";
import HeaderMobile from "../../components/HeaderMobile";
import { ourCultureBg } from '../../assets';
import ourMission from "../../assets/OurMission.png";
import ourVision from "../../assets/OurVision.png";

function AboutUs() {
    const [selectedPoint, setSelectedPoint] = useState(null);
    const whyUsData = [
        {
            id: 1,
            heading: "Advanced Technology",
            content: "We leverage state-of-the-art tools like our proprietary Applicant Tracking System (ATS) and AI-driven solutions to enhance efficiency and ensure precise candidate matching.",
        },
        {
            id: 2,
            heading: "Streamlined Processes",
            content: "Our meticulous processes are designed to deliver seamless and effective staffing solutions tailored to your organization's needs, from initial consultation to final placement.",
        },
        {
            id: 3,
            heading: "Core Values",
            content: "Integrity, transparency, and reliability are at the heart of everything we do. We uphold these values in every client interaction, ensuring trustworthy and ethical service."
        },
        {
            id: 4,
            heading: "Proven Expertise",
            content: "With extensive industry knowledge and a track record of successful placements, we bring deep insights and understanding across various sectors.",
        },
        {
            id: 5,
            heading: "Long-Term Partnership",
            content: "We prioritize building enduring relationships with our clients, providing ongoing support and strategic guidance to support your organizational growth and success.",
        }
    ]
    useEffect(() => {
        if (selectedPoint === null) {
            setSelectedPoint(whyUsData[0])
        }
    }, [])
    useEffect(() => {
        const interval = setInterval(() => {
            setSelectedPoint(prevPoint => {
                const currentIndex = prevPoint ? prevPoint.id - 1 : 0; // Convert to zero-based index
                const nextIndex = (currentIndex + 1) % whyUsData.length;
                return whyUsData[nextIndex];
            });
        }, 10000);

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    const handlePointClick = (item, index) => {
        setSelectedPoint(item);
    }
    return (
        <div className={style.aboutUs_section}>

            <HeaderMobile />

            <div className={style.knowAboutContainer}>
                    
                <Header />
        
                <img src={ourCultureBg} alt="background image" />

                <div className={style.content_container}>
                    <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="0">Shaping Careers. Building Teams. Fueling Futures.</p>
                    <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="250">We combine smart technology with human understanding to deliver staffing solutions that drive success with purpose.</p>
                </div>
            </div>

            <div className={style.NewVisionNewMission_container}>
                <img  
                    data-aos="zoom-in"
                    data-aos-duration="1000"  
                    src={ourVision} alt="our vission"
                />
                <img 
                    data-aos="zoom-in"
                    data-aos-duration="1000"  
                    src={ourMission} alt="our mission" 
                />                
            </div>

            <LeadershipUpdated />

            <SpecialTable />

            {/* Video Section */}
            <div className={style.video_container}>
                <VideoComponent heading="Experience Our Culture" content="Get a glimpse into our vibrant workplace! Watch our cultural video to see how we collaborate, innovate, and celebrate as a team." />
            </div>

            {/* Top Talent Section */} 
            <div className={style.TopTalent_outer_Container}>
                <TopTalentCard heading="Let’s Build Careers, Together" content="Looking for growth-driven opportunities or the right talent to elevate your team? Drop your CV or hire top-notch talent today." cardBGColor="#12151D" hColor="white" pColor= "white" />
            </div>  

        </div >
    )
}

export default AboutUs